<template>
  <div class="filter-senior">
    <el-collapse-item v-if="!isGraphReport" class="panel-title" title="系统默认筛选">
       <el-form class="form">
        <el-row class="type-filter" :gutter="20">
          <el-col :span="10"><label>筛选表达式</label> </el-col>
          <el-col :span="14"><label>高级模式</label> <el-switch v-model="systemFilterSwitch" @change="changeFilterState"></el-switch></el-col>
        </el-row>
        <el-row class="input-type">
          <div @click="openPrimaryFilter" v-if="!systemFilterSwitch">
            <input :value="value" disabled/>
          </div>
          <div v-else class="formula" @click="openSeniorFilter" v-html='seniorConvert(this.value)'></div>
        </el-row>
        <el-row class="type-filter" :gutter="20" v-if="this.reportService.report.groupByEnable">
          <el-col :span="10"><label>分组筛选</label> </el-col>
        </el-row>
        <el-row class="input-type" v-if="this.reportService.report.groupByEnable">
          <div class="formula" @click="openHavingFilter" v-html='seniorConvert(this.groupFilterExpressionStr)'></div>
        </el-row>
      </el-form>
    </el-collapse-item>
    <div v-else class="panel-title">
      <el-form class="form">
        <el-row class="type-filter" :gutter="20">
          <el-col :span="10"><label>筛选表达式</label> </el-col>
          <el-col :span="14"><label>高级模式</label> <el-switch v-model="systemFilterSwitch" @change="changeFilterState"></el-switch></el-col>
        </el-row>
        <el-row class="input-type">
          <div @click="openPrimaryFilter" v-if="!systemFilterSwitch">
            <input :value="value" disabled/>
          </div>
          <div v-else class="formula" @click="openSeniorFilter" v-html='seniorConvert(this.value)'></div>
        </el-row>
        <el-row class="type-filter" :gutter="20" v-if="this.reportService.report.groupByEnable">
          <el-col :span="10"><label>分组筛选</label> </el-col>
        </el-row>
        <el-row class="input-type" v-if="this.reportService.report.groupByEnable">
          <div class="formula" @click="openHavingFilter" v-html='seniorConvert(this.groupFilterExpressionStr)'></div>
        </el-row>
      </el-form>
    </div>
     <logic-panel :logicPanelData="logicPanelData" @expression="expression"></logic-panel>
  </div>
</template>

<script>
import LogicPanel from './logic-panel'
import { Expression } from '@/shared/expressdion'
export default {
  name: 'SeniorFilter',
  inject: ['reportService'],
  props: {
    isGraphReport: {
      default: false
    }
  },
  data () {
    return {
      systemFilterSwitch: this.$_.cloneDeep(this.reportService.report.systemFilterSwitch),
      logicPanelData: {
        filters: [],
        table: {},
        dialogVisible: false,
        expression: ''
      },
      value: '',
      groupFilterExpressionStr: ''
    }
  },
  components: {
    LogicPanel
  },
  mounted () {
    this.groupFilterExpressionStr = this.reportService.report.groupFilterExpressionStr
    if (this.systemFilterSwitch) {
      this.value = this.reportService.report.filterExpression
    } else {
      let filters = this.reportService.report.filters.filter(m => {
        return m.filterType === 'senior'
      })
      let expression = this.reportService.report.filterExpression
      if (filters.length > 0 && expression !== '') {
        this.convert(filters, expression)
      }
    }
  },
  methods: {
    changeFilterState (value) {
      if (!this.value) {
        return
      }
      this.$confirm('', '筛选表达式会被清空值,继续操作吗?', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        customClass: 'deleMessageBox',
        center: true
      }).then(() => {
        this.value = ''
        this.$emit('updateSeniorFilter', {filters: [], expression: '', systemFilterSwitch: value})
      }).catch(() => {
        this.systemFilterSwitch = !value
      })
    },

    openPrimaryFilter () {
      if (this.reportService.report.mainTableId !== '') {
        this.logicPanelData.table.id = this.reportService.report.id
        this.logicPanelData.expression = this.reportService.report.filterExpression
        this.logicPanelData.table.name = this.reportService.report.name
        this.logicPanelData.table.columns = this.reportService.report.columns
        this.logicPanelData.filters = this.reportService.report.filters.filter(m => {
          return m.filterType === 'senior'
        })
        // 打开高级属性面板
        this.logicPanelData.dialogVisible = true
      }
    },
    expression (logicPanelData) {
      this.convert(logicPanelData.filters, logicPanelData.expression)
      this.$emit('updateSeniorFilter', {filters: logicPanelData.filters, expression: logicPanelData.expression, systemFilterSwitch: this.systemFilterSwitch})
    },
    convert (filters, expression) {
      // 转换,
      if (expression !== null && expression !== '') {
        let tempExpression = expression
        expression.match(/\$\{(.+?)\}/g).forEach(m => {
          let filterId = m.substring(2, m.length - 1)
          let filter = filters.find(filter => filter.filterId === filterId)
          let str = ''
          if (filter) {
            let column = this.reportService.report.columns.find(m => m.id === filter.columnId)
            if (filter.type === 'IsNull' || filter.type === 'IsNotNull') {
              str = ` ${Expression.getOperation(filter.type)}(${column.name}) `
            } else {
              str = ` ${column.name} ${Expression.getOperation(filter.type)} ${filter.defaultValue} `
            }
          }
          tempExpression = tempExpression.replace(m, str)
        })
        this.value = tempExpression
      }
    },
    openSeniorFilter () {
      this.$Popup.calculation({
        parameter: {
          title: '表达式设计',
          expression: this.value,
          dataSource: this.reportService.getReportJoinTables(),
          functionType: ['text', 'date', 'logic', 'system'],
          calculationType: 'sql',
          currentTableColumns: this.reportService.report.columns
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          this.value = data.value
          this.$emit('updateSeniorFilter', {filters: [], expression: this.value, systemFilterSwitch: this.systemFilterSwitch})
        }
      })
    },
    openHavingFilter () {
      this.$Popup.calculation({
        parameter: {
          title: '表达式设计',
          expression: this.groupFilterExpressionStr,
          dataSource: this.reportService.getReportJoinTables(),
          functionType: ['text', 'date', 'logic', 'system'],
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          this.groupFilterExpressionStr = data.value
          this.$emit('updateGroupFilterExpressionStr', this.groupFilterExpressionStr)
        }
      })
    },
    seniorConvert (expression) {
      // 转换,
      if (expression) {
        expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map(el => {
          let codeAttr = el.replace(/[${}]/g, '').split(',')
          let code = `&nbsp;<span contenteditable='false' dataId=${codeAttr[0]} name=${codeAttr[1]} type=${codeAttr[2]}>${codeAttr[1]}</span>&nbsp;`
          expression = expression.replace(el, code)
        })
        return expression
      }
    }
  }
}
</script>

<style lang="scss">
.filter-senior {
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  .form{
      margin: 0;
      .el-form-item__content {
        float: right;
      }
      .input-type {
        height: 28px;
        input {
          border-radius: 4px;
          border: 1px solid #c0c4cc;
          width: 204px;
          height: 28px;
          line-height: 28px;
          cursor: pointer;
        }
         .formula {
          position: absolute;
          margin-top: -14px;
          padding: 0 10px;
          top: 50%;
          outline: none;
          border: 1px solid #c0c4cc;
          background: rgb(235,235,228);
          border-radius: 4px;
          max-height: 80px;
          overflow: hidden;
          width: 100%;
          height: 28px;
          line-height: 28px;

          code {
            padding: 2px 4px;
            font-size: 90%;
            color: #c7254e;
            background-color: #f9f2f4;
            border-radius: 4px;
          }
        }
      }
    .type-filter{
      label{
        font-size: 12px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/report/design/filter-senior-panel.vue